var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentSucces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.6239 47.6133H43.14H38.8601H16.3763L11.0859 58.1939H15.871V82.0004H66.1291V58.1939H70.9142L65.6239 47.6133ZM63.9892 50.2584L66.6343 55.5488H45.7852L43.14 50.2584H63.9892ZM18.011 50.2584H38.8601L36.215 55.5488H15.3658L18.011 50.2584ZM63.4839 79.3552H42.3226V70.0972H39.6775V79.3552H18.5162V58.1939H37.8497L39.6775 54.5383V66.1294H42.3226V54.5383L44.1505 58.1939H63.4839V79.3552Z",
    fill: "#B1C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.0966 68.7744H21.1611V71.4196H29.0966V68.7744Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.0966 74.0645H21.1611V76.7096H29.0966V74.0645Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.3873 74.0645H31.7422V76.7096H34.3873V74.0645Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.8933 21.5099L41.001 19.9532L47.1087 21.5085L47.5875 14.9499L50.8318 9.40826L45.0931 6.92445L41.001 1.86426L36.9076 6.92445L31.1689 9.40826L34.4132 14.9499L34.8933 21.5099ZM38.5556 9.09216L41.001 6.07006L43.4465 9.09348L47.0412 10.6502L44.9952 14.1457L44.7016 18.1677L41.001 17.2247L37.3004 18.1664L37.0068 14.1444L34.9608 10.6488L38.5556 9.09216Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.5221 24.2097L16.4438 20.9284L13.0395 19.4537L10.5808 16.4131L8.1221 19.4524L4.71777 20.9271L6.63948 24.2084L6.92384 28.1219L10.5808 27.1921L14.239 28.1232L14.5221 24.2097ZM11.9298 23.4029L11.8293 24.7797L10.5808 24.4623L9.33358 24.7797L9.23174 23.4029L8.50829 22.1663L9.76871 21.6201L10.5808 20.6189L11.3915 21.6214L12.6519 22.1676L11.9298 23.4029Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M75.3609 24.2097L77.2826 20.9284L73.8783 19.4537L71.4196 16.4131L68.961 19.4524L65.5566 20.9271L67.4783 24.2084L67.7627 28.1219L71.4196 27.1921L75.0779 28.1232L75.3609 24.2097ZM72.7687 23.4029L72.6682 24.7797L71.4196 24.4623L70.1724 24.7797L70.0719 23.4029L69.3485 22.1663L70.6089 21.6201L71.4196 20.6189L72.2304 21.6214L73.4908 22.1676L72.7687 23.4029Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.4594 31.5198C18.9776 33.1995 21.2154 35.2495 23.1054 37.6143L28.3441 44.1597L27.2609 35.4942C26.6949 30.9696 24.2785 26.8048 20.6308 24.0697L19.3638 23.1201L15.4873 30.8718L16.4594 31.5198ZM20.2711 27.2214C22.5076 29.3376 24.0246 32.1547 24.5443 35.2019C22.8739 33.2405 20.9787 31.4921 18.889 29.9856L20.2711 27.2214Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M54.7394 35.4945L53.6562 44.1601L58.895 37.6133C60.7863 35.2485 63.0228 33.1985 65.541 31.5188L66.5117 30.8708L62.6353 23.1191L61.3682 24.0714C57.7219 26.8065 55.3042 30.97 54.7394 35.4945ZM63.1114 29.986C61.0217 31.4924 59.1251 33.2395 57.456 35.2022C57.9771 32.155 59.4928 29.3379 61.7293 27.2218L63.1114 29.986Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.29 44.9683H48.9352V39.4267C48.9352 33.0744 51.1743 26.89 55.2426 22.0083L53.2098 20.3154C48.7474 25.6706 46.29 32.458 46.29 39.4267V44.9683Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M58.194 15.8711H55.5488V18.5163H58.194V15.8711Z",
    fill: "#60646A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M62.1618 10.5811H59.5166V13.2262H62.1618V10.5811Z",
    fill: "#60646A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M33.0649 44.9683H35.71V39.4267C35.71 32.4567 33.2527 25.6706 28.7916 20.3154L26.7588 22.0083C30.8257 26.89 33.0649 33.0744 33.0649 39.4267V44.9683Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M26.4518 15.8711H23.8066V18.5163H26.4518V15.8711Z",
    fill: "#60646A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M22.484 10.5811H19.8389V13.2262H22.484V10.5811Z",
    fill: "#60646A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M42.3229 22.4834H39.6777V25.1286H42.3229V22.4834Z",
    fill: "#60646A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M42.3229 27.7744H39.6777V44.968H42.3229V27.7744Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M79.3551 35.71H76.71V38.3551H79.3551V35.71Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M79.3551 41H76.71V43.6452H79.3551V41Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M81.9997 38.3545H79.3545V40.9997H81.9997V38.3545Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M76.7096 38.3545H74.0645V40.9997H76.7096V38.3545Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M75.3873 0H72.7422V2.64516H75.3873V0Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M75.3873 5.29004H72.7422V7.9352H75.3873V5.29004Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M78.0319 2.64551H75.3867V5.29067H78.0319V2.64551Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M72.7418 2.64551H70.0967V5.29067H72.7418V2.64551Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M5.29067 41H2.64551V43.6452H5.29067V41Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M5.29067 46.29H2.64551V48.9352H5.29067V46.29Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M7.9352 43.6455H5.29004V46.2907H7.9352V43.6455Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M2.64516 43.6455H0V46.2907H2.64516V43.6455Z",
    fill: "#23D32A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M5.29067 0H2.64551V2.64516H5.29067V0Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M5.29067 5.29004H2.64551V7.9352H5.29067V5.29004Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M7.9352 2.64551H5.29004V5.29067H7.9352V2.64551Z",
    fill: "#5086FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M2.64516 2.64551H0V5.29067H2.64516V2.64551Z",
    fill: "#5086FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSucces);
export default __webpack_public_path__ + "static/media/paymentSucces.45a7d0e47001319fb8b784a989cb796f.svg";
export { ForwardRef as ReactComponent };